import { EventEmitter } from 'expo-modules-core';

import ExpoLocation from './ExpoLocation';

export const LocationEventEmitter = new EventEmitter(ExpoLocation);
